import React from "react";
import Box from "@mui/material/Box";
import resetPng from "src/assets/images/reset.png"; // ✅ place your PNG in this folder

const ResetIcon = ({ size = 55, ...props }) => (
  <Box
    component="img"
    src={resetPng}
    alt="Reset Icon"
    sx={{
      width: size,
      height: size,
      display: "inline-block"
    }}
    {...props}
  />
);

export default ResetIcon;
